<template>
  <div class="packaging-section container">
    <div class="packaging-section__image-wrap">
      <img
        src="/static/images/artwork.png"
        class="packaging-section__image"
      >
    </div>
    <div class="packaging-section__content">
      <h4 class="packaging-section__title">
        Your branded products and packaging
      </h4>
      <div class="packaging-section__description">
        We can put your company logo on any product or packaging building value in your brand and better experiences for your customers.
      </div>
      <div class="packaging-section__info">
        <box-icon />
        <span><strong>Making the experience best.</strong> In addition to your logo, add custom notes that feel personal, promotional materials and more included in your product’s packaging.</span>
      </div>
    </div>
  </div>
</template>

<script>
import BoxIcon from 'static/assets/icons/BoxIcon.svg'

export default {
  name: 'PackagingSection',
  components: {
    BoxIcon,
  },
}
</script>

<style lang="sass">
@import '~styles/shared'

.packaging-section
  padding-bottom: 35px
  overflow: hidden

  @include tablet
    display: flex
    padding-top: 41px

  @include widescreen
    max-width: 1281px
    padding-bottom: 10px

.packaging-section__content
  margin-top: -5px

  @include tablet
    margin-top: 12px
    line-height: 32px

  @include widescreen
    margin-top: 69px
    padding-right: 84px

.packaging-section__title
  font-size: 28px
  font-weight: 500
  letter-spacing: -.5px
  padding-right: 10px
  color: #1d3763
  margin-bottom: 23px
  line-height: 32px

  @include tablet
    font-size: 35px
    line-height: 39px
    letter-spacing: -.7px
    padding-right: 0

  @include widescreen
    padding-right: 90px
    margin-bottom: 28px

.packaging-section__description
  color: #525f7f
  letter-spacing: .1px

.packaging-section__image-wrap
  margin-top: 7px
  width: 336px
  position: relative
  left: -13px
  margin-left: auto
  margin-right: auto
  flex-shrink: 0

  @include mobile-smaller
    left: 10px

  @include tablet
    margin-top: 4px
    width: 50%
    left: 2px
    margin-right: 18px

  @include widescreen
    width: 601px
    left: 6px
    margin-top: 10px
    margin-right: 90px

.packaging-section__info
  display: flex
  align-items: flex-start
  margin-top: 13px
  font-size: 17px
  line-height: 26px
  letter-spacing: -.1px
  color: #525f7f

  @include widescreen
    margin-top: 18px

  strong
    color: #404851
    font-weight: 600

  svg
    width: 47px
    height: 47px
    flex-shrink: 0
    margin-top: 4px
    margin-right: 24px
    position: relative
    left: -4px
</style>



// WEBPACK FOOTER //
// src/PackagingSection.vue